import DangerousIcon from '@mui/icons-material/Dangerous'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ptBR } from 'date-fns/locale'
import { useState } from 'react'

import { MenuItem, Select } from '@mui/material'
import { Col, Container, Row } from 'react-bootstrap'
import { Bar, Doughnut } from 'react-chartjs-2'

import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import DashboardHeader from '../headers/dashboard.header'

interface IRewardsManagementDashboardProps {}

export const RewardsManagementDashboard: React.FC<
  IRewardsManagementDashboardProps
> = () => {
  const [selectedCategory, setSelectedCategory] = useState('healthAndBeauty')

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
  )

  const DropdownProps = {
    PaperProps: {
      style: {
        width: 160,
        maxHeight: 500
      }
    }
  }
  const title = 'Gestão de Benefícios'
  const description = ''

  const categoryOptions = [
    {
      label: 'Saúde e Beleza',
      value: 'healthAndBeauty'
    },
    {
      label: 'Postos de Combustível',
      value: 'fuelStation'
    }
  ]

  const rewardedTypes = {
    labels: ['Resgatado', 'Exp. em breve', 'Expirado'],
    datasets: [
      {
        data: [getRandomData(), getRandomData(), getRandomData()],
        backgroundColor: ['#78ccda', '#16BE94', '#e27781'],
        borderWidth: 0
      }
    ]
  }

  const fuelTypes = {
    labels: ['Gasolina', 'Etanol', 'Diesel', 'GNV'],
    datasets: [
      {
        data: [
          getRandomData(),
          getRandomData(),
          getRandomData(),
          getRandomData()
        ],
        backgroundColor: ['#16BE94', '#6783E6', '#000000', '#8d8d8d'],
        borderWidth: 0
      }
    ]
  }

  const typeOptions = {
    responsive: true,
    cutout: 120,
    gridLines: {
      display: false
    },
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          color: '#FFFFFF',
          font: {
            size: 12,
            family: "'Montserrat', sans-serif"
          }
        }
      },
      datalabels: {
        color: 'white',
        font: {
          size: 14,
          family: "'Montserrat', sans-serif"
        },
        formatter(value: any) {
          return `${value}%`
        }
      }
    }
  }

  const barOptions = {
    responsive: true,
    gridLines: {
      display: false
    },
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        color: 'white',
        font: {
          size: 12,
          family: "'Montserrat', sans-serif"
        }
      }
    },
    maintainAspectRatio: true,
    scales: {
      x: {
        ticks: {
          color: 'white',
          font: {
            size: 12,
            family: "'Montserrat', sans-serif"
          }
        },
        grid: {
          display: true,
          tickColor: 'white',
          drawOnChartArea: false,
          color: 'white'
        },
        border: {
          color: 'white'
        }
      },
      y: {
        ticks: {
          color: 'white',
          font: {
            size: 12,
            family: "'Montserrat', sans-serif"
          }
        },
        grid: {
          display: true,
          tickColor: 'white',
          drawOnChartArea: false,
          color: 'white'
        },
        border: {
          color: 'white'
        }
      }
    }
  }

  function getRandomData() {
    return Math.floor(Math.random() * 100)
  }

  function getRandomColor() {
    var letters = '0123456789ABCDEF'.split('')
    var color = '#'
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  const healthAndBeautyData = {
    labels:
      selectedCategory === 'healthAndBeauty'
        ? [
            'Estética',
            'Limpeza Facial',
            'Massagem',
            'Pés & Mãos',
            'Limpeza Completa',
            'Aspiração',
            'Troque e Ganhe'
          ]
        : [
            'Abastecimento',
            'Troca de óleo',
            'Lava rápido',
            'Limpeza completa',
            'Aspiração',
            'Troque e Ganhe'
          ],
    datasets: [
      {
        label: '',
        data: [
          getRandomData(),
          getRandomData(),
          getRandomData(),
          getRandomData(),
          getRandomData(),
          getRandomData(),
          getRandomData()
        ],
        backgroundColor: [
          getRandomColor(),
          getRandomColor(),
          getRandomColor(),
          getRandomColor(),
          getRandomColor(),
          getRandomColor(),
          getRandomColor()
        ],
        barThickness: 35
      }
    ]
  }

  function getRandomValueData() {
    return Math.floor(Math.random() * 100000)
      .toFixed(2)
      .toLocaleString()
  }

  function viewDashboard() {
    return (
      <Container fluid className="dashboard-body financial">
        <Row>
          <Col sm="12" className="dashboard-sweet">
            <Row>
              <Col sm="12">
                <div className="financial-card">
                  <div className="card-item ship">
                    <div className="d-flex flex-column align-items-center">
                      <h4 className="card-label">Receita Gerada</h4>
                      <div className="d-flex align-items-center mt-2">
                        <div className="d-flex align-items-center">
                          <div className="card-data" style={{ fontSize: 22 }}>
                            R$ {getRandomValueData()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-item total">
                    <div className="d-flex flex-column align-items-center">
                      <h4 className="card-label">Resgatados</h4>
                      <div className="d-flex align-items-center mt-2">
                        <div className="d-flex align-items-center">
                          <div
                            className="card-data mb-3"
                            style={{ fontSize: 22 }}
                          >
                            <EmojiEventsIcon
                              fontSize="large"
                              className="me-2 mb-1"
                            />
                            {getRandomData()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-item monthly-payment">
                    <div className="d-flex flex-column align-items-center">
                      <h4 className="card-label">Exp. em breve</h4>
                      <div className="d-flex align-items-center mt-2">
                        <div className="d-flex align-items-center">
                          <div
                            className="card-data mb-3"
                            style={{ fontSize: 22 }}
                          >
                            <ScheduleIcon
                              fontSize="large"
                              className="me-2 mb-1"
                            />
                            {getRandomData()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-item delay">
                    <div className="d-flex flex-column align-items-center">
                      <h4 className="card-label">Expirados</h4>
                      <div className="d-flex align-items-center mt-2">
                        <div className="d-flex align-items-center">
                          <div className="card-data" style={{ fontSize: 22 }}>
                            <DangerousIcon
                              fontSize="large"
                              className="me-2 mb-1"
                            />
                            {getRandomData()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedCategory === 'fuelStation' && (
                    <div className="card-item opened">
                      <div className="d-flex flex-column align-items-center">
                        <h4 className="card-label">Litros</h4>
                        <div className="d-flex align-items-center mt-2">
                          <div className="d-flex align-items-center">
                            <div className="card-data" style={{ fontSize: 22 }}>
                              <LocalGasStationIcon
                                fontSize="large"
                                className="me-2 mb-1"
                              />
                              {getRandomData()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-between">
              <Select
                sx={{ fontSize: 12, width: 230 }}
                labelId="selected-category"
                className="mt-4 ms-3"
                id="selected-category-select"
                variant="standard"
                value={selectedCategory}
                onChange={e => setSelectedCategory(e.target.value)}
                label="Categoria"
                MenuProps={DropdownProps}
              >
                {categoryOptions?.map(
                  (
                    option: any,
                    index: {
                      toString: () => React.Key | null | undefined
                    }
                  ) => (
                    <MenuItem
                      selected={selectedCategory === option.value}
                      key={index.toString()}
                      value={option.value}
                    >
                      {option.label}
                    </MenuItem>
                  )
                )}
              </Select>
              <LocalizationProvider
                adapterLocale={ptBR}
                dateAdapter={AdapterDateFns}
              >
                <DesktopDatePicker
                  label="Visão mensal"
                  views={['year', 'month']}
                  sx={{ minWidth: 160, fontSize: 42 }}
                  slotProps={{
                    textField: {
                      variant: 'standard'
                    }
                  }}
                  className="mt-2 me-3"
                />
              </LocalizationProvider>
            </div>
            {selectedCategory === 'healthAndBeauty' && (
              <Row>
                <Col md={7} className="page-sweet mt-4">
                  <h4 className="text-center mb-3">
                    {categoryOptions
                      .find(category => category.value === selectedCategory)
                      ?.label?.toUpperCase()}
                  </h4>
                  <Row>
                    <Col>
                      <Bar
                        className="mt-4"
                        options={barOptions}
                        data={healthAndBeautyData}
                        height={138}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="page-sweet mt-4">
                  <h4 className="text-center mb-3">STATUS</h4>
                  <Row>
                    <Col>
                      <div
                        className="d-flex flex-column align-items-center"
                        style={{ height: 320 }}
                      >
                        <Doughnut
                          className="mb-3"
                          data={rewardedTypes}
                          options={typeOptions}
                          height={25}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {selectedCategory === 'fuelStation' && (
              <>
                <Row>
                  <Col md={12} className="page-sweet mt-4">
                    <h4 className="text-center mb-3">
                      {categoryOptions
                        .find(category => category.value === selectedCategory)
                        ?.label?.toUpperCase()}
                    </h4>
                    <Row>
                      <Col>
                        <Bar
                          className="mt-4"
                          options={barOptions}
                          data={healthAndBeautyData}
                          height={80}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="d-flex justify-content-between">
                  <Col md={6} className="page-sweet mt-4">
                    <h4 className="text-center mb-3">COMBUSTÍVEL</h4>
                    <Row>
                      <Col>
                        <div
                          className="d-flex flex-column align-items-center"
                          style={{ height: 350 }}
                        >
                          <Doughnut
                            className="mb-3"
                            data={fuelTypes}
                            options={typeOptions}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={4} className="page-sweet mt-4">
                    <h4 className="text-center mb-3">STATUS</h4>
                    <Row>
                      <Col>
                        <div
                          className="d-flex flex-column align-items-center"
                          style={{ height: 350 }}
                        >
                          <Doughnut
                            className="mb-3"
                            data={rewardedTypes}
                            options={typeOptions}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <div className="dashboard">
      <DashboardHeader title={title} description={description} />
      {viewDashboard()}
    </div>
  )
}

export default RewardsManagementDashboard

